import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { searchBusinessPlaceForAgencyFailure, searchBusinessPlaceForAgencySuccess } from '../actions/searchBusinessPlaceForAgencyActions';

function* searchBusinessPlaceForAgency({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.searchBusinessPlaceForAgency + `?placeName=` + encodeURIComponent(payload),
            isAuth: true,
        });
        console.log('====================================');
        console.log("SEARCH_BUSINESS_PLACE_FOR_AGENCY_SUCCESS status :", response.data.status);
        console.log("SEARCH_BUSINESS_PLACE_FOR_AGENCY_SUCCESS data :", response.data.response);
        console.log("SEARCH_BUSINESS_PLACE_FOR_AGENCY_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            searchBusinessPlaceForAgencySuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("SEARCH_BUSINESS_PLACE_FOR_AGENCY_FAILURE status :", error?.response?.status);
        console.log("SEARCH_BUSINESS_PLACE_FOR_AGENCY_FAILURE data:", error?.response?.data);
        console.log("SEARCH_BUSINESS_PLACE_FOR_AGENCY_FAILURE error :", error);
        console.log('====================================');
        yield put(searchBusinessPlaceForAgencyFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* searchBusinessPlaceForAgencySaga() {
    yield takeLatest(actionTypes.SEARCH_BUSINESS_PLACE_FOR_AGENCY_REQUEST, searchBusinessPlaceForAgency);
}

export default searchBusinessPlaceForAgencySaga;
